import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Box from "../UI/Box";
import CardAuthor from "./CardAuthor";

function CardColumn({ tag, row, data }) {
  return (
    <Wrapper className={`${row ? "row" : ""}`}>
      <Box shadow={true}>
        <img
          src="https://flexiblog-science.netlify.app/static/3d4e704005d426384ec3bd056502511f/6b99c/image.webp"
          alt=""
        />
        <div className="inner">
          <div className="top">
            {tag && (
              <NavLink to={"/"} className="tag">
                Space
              </NavLink>
            )}

            <NavLink to={`/posts/${data.id}`} className="article-title">
              {data.post_title}
            </NavLink>
          </div>
          <CardAuthor
            name={
              data.post_author_first_name + " " + data.post_author_second_name
            }
            img={data.post_author_image}
            date={new Date(data.post_date).toDateString().slice(3, 100)}
            min={data.post_views_count}
            link={data.post_author_id}
          />
        </div>
      </Box>
    </Wrapper>
  );
}

export default CardColumn;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  &.row > div {
    flex-direction: row;
  }
  @media (max-width: 767px) {
    & > div {
      flex-direction: row !important;
      justify-content: space-between !important;
    }
  }
  & > div > img {
    width: auto;
    border-radius: 0.5rem;
    overflow: hidden;
    width: 100%;
    flex: 0 0 240px;
    object-fit: cover;
    object-position: center;
    @media (max-width: 767px) {
      flex: 0 0 130px;
    }
  }
  & > div {
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
  }
  .shadow {
    height: 100%;
  }
  .inner {
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 24px;
    height: 100%;
    padding-top: 32px;
    @media (max-width: 767px) {
      width: 100%;
      padding: 12px;
    }
    .main-title {
      margin-top: 16px;
      color: white;
    }
    .tag {
      width: fit-content;
      display: flex;
      margin-top: 0;
      margin-bottom: 16px;
    }
    .article-title {
      @media (max-width: 767px) {
        font-size: 16px;
      }
    }
    p {
      font-size: 0.875rem;
      margin-top: 16px;
    }
  }
`;
